import { Heading } from '../../typography/heading/Heading';
import { Text } from '../../typography/text/Text';
import Title from '../../typography/title/Title';
import styles from './DefaultHeading.module.scss';
import PropTypes from 'prop-types';
import React from 'react';

const DefaultHeading = ({
  label = '',
  title = '',
  subtitle = '',
  padding,
  labelDesktopLineHeight,
  labelDesktopFontSize,
  labelMobileFontSize,
  titleDesktopFontSize,
  titleMobileFontSize,
  subTitleDesktopFontSize,
  subTitleMobileFontSize,
  subTitleMobileLineHeight,
  labelTextTransform,
  titleTextTransform,
  subtitleTextTransform,
}) => {
  return (
    <div
      className={styles.root}
      style={{
        '--label-font-size-desktop': labelDesktopFontSize
          ? `${labelDesktopFontSize}px`
          : '18px',
        '--label-font-size-mobile': labelMobileFontSize
          ? `${labelMobileFontSize}px`
          : '14px',
        '--title-font-size-desktop': titleDesktopFontSize
          ? `${titleDesktopFontSize}px`
          : '24px',
        '--title-font-size-mobile': titleMobileFontSize
          ? `${titleMobileFontSize}px`
          : '20px',
        '--subtitle-font-size-desktop': subTitleDesktopFontSize
          ? `${subTitleDesktopFontSize}px`
          : '16px',
        '--subtitle-font-size-mobile': subTitleMobileFontSize
          ? `${subTitleMobileFontSize}px`
          : '14px',
        '--padding': `${padding || 0}px`,
        '--label-line-height-desktop': `${labelDesktopLineHeight || 19}px`,
        '--subtitle-line-height-mobile': `${subTitleMobileLineHeight || 20}px`,
      }}
    >
      <Title className={styles.titleWrapper}>
        {label && (
          <Text as="span" textTransform={labelTextTransform}>
            {label}
          </Text>
        )}
        {title && (
          <Heading as="h2" textTransform={titleTextTransform}>
            {title}
          </Heading>
        )}
        {subtitle && (
          <Text as="p" textTransform={subtitleTextTransform}>
            {subtitle}
          </Text>
        )}
      </Title>
    </div>
  );
};

DefaultHeading.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default DefaultHeading;
